<template>
  <div style="border-radius: 8px" class="row">
    <div class="border">
      <div class="card ps-2">
        <div class="col-md-2 col-12">
          <div class="mb-1">
            <button onclick="window.print()" class="btn btn-primary mt-1">Print</button>
          </div>
        </div>
      </div>
      <div class="bg-white p-2 row">
        <DefaultTemplate v-if="!activeTemplate || activeTemplate === 'default'" :company="company" :cardInfo="cardInfo" :qrcode="qrcode" />
        <TemplateOne v-if="activeTemplate && activeTemplate === 'template_one'" :cardInfo="cardInfo" :barcode="barcode" />
        <TemplateTwo v-if="activeTemplate && activeTemplate === 'template_two'" :company="company" :cardInfo="cardInfo" :qrcode="qrcode" />
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import handleCompanyContact from "@/services/modules/companyContact";
import handleBarcode from "@/services/modules/barcode";
import handleHospital from "@/services/modules/hospital";
import {useStore} from "vuex";
import DefaultTemplate from "@/views/page/company/hospital/patient/PatientCardTemplate/DefaultTemplate";
import TemplateOne from "@/views/page/company/hospital/patient/PatientCardTemplate/TemplateOne";
import TemplateTwo from "@/views/page/company/hospital/patient/PatientCardTemplate/TemplateTwo";
import handleCompany from "@/services/modules/company";

const {fetchContactDetails} = handleCompanyContact();
const { fetchActiveCustomizationManagerTemplate } = handleCompany();
const {calculateAge} = handleHospital();
const {fetchBarcode} = handleBarcode();
const route = useRoute();
const store = useStore();

let companyId = computed(() => route.params.companyId);
let company = computed(() => store.getters['company/getCompany']);
let qrcode = ref(null);
let barcode = ref(null);
let activeTemplate = ref(null);

let cardInfo = ref({
  quantity: '',
  birthday: '',
  format_birthday: '',
  gender: '',
  full_name: '',
  serial_no: '',
  photo:'',
});

const getContactDetails = async (patientId, type = 'activities') => {
  try {
    const res = await fetchContactDetails(type, patientId, '?company_id=' + companyId.value);
    if (!res.status) {
      return cardInfo.value = {}
    }
    cardInfo.value = res.data.contact_profile;
    getBarCode(cardInfo.value.serial_no)
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  }
}

const getActiveTemplate = async () => {
  let query = '?company_id=' + companyId.value + '&type=html&form_name=patient_card'
  const fetchSingleData = fetchActiveCustomizationManagerTemplate(query);
  fetchSingleData.then(res => {
    if (!res.status){
       activeTemplate.value = null;
       return
    }
    activeTemplate.value = res.data.template_name
  });
}

const getBarCode = (serial_no) => {
  fetchBarcode(`?code=${serial_no}&qrcode=${serial_no}&qrcode_width=3&qrcode_height=3&width=2`).then((res) => {
    qrcode.value = res.qrcode;
    barcode.value = res.barcode;
  })
}



onMounted(async () => {
  await getContactDetails(route.params.patientId)
  await getActiveTemplate()
})

</script>

<style>

</style>
